import { AiOutlineInstagram, AiFillGithub } from 'react-icons/ai';
import { FaLinkedin } from 'react-icons/fa';

const data = [
  {
    id: 2,
    link: 'https://www.linkedin.com/in/kravazf',
    icon: <FaLinkedin />,
  },
  {
    id: 3,
    link: 'https://github.com/Kravazf',
    icon: <AiFillGithub />,
  },
  {
    id: 1,
    link: 'https://www.instagram.com/maxkrav4enko/',
    icon: <AiOutlineInstagram />,
  },
];

export default data;
